module.exports = __webpack_public_path__ + "media/application/images/decision-maker-bg-cbb84835fadc7ec55cf3b36ca41c80f7.webp";